import lightGallery from 'lightgallery';

document.querySelectorAll('.o-image-gallery__list').forEach((imagegallery) => {
  lightGallery(imagegallery, {
    speed: 500,
  });
});
